enum CustomReportContentTypes {
  HTML = 'HTML',
  COLUMN = 'Column',
  ROW = 'Row',
  CHART = 'Chart',
  PROGRESS_BAR = 'ProgressBar',
}

export default CustomReportContentTypes
